import { BREAKPOINTS, COLORS, SystemIcons } from '@laerdal/life-react-components';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMarketPath } from '../store/slices/globalConfigSlice';

const Contact = styled.button`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  width: 100%;

  border-radius: 8px;
  border: none;
  background: ${COLORS.primary_20};
  cursor: pointer;
  text-align: left;

  ${BREAKPOINTS.MEDIUM}{
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

const IconCircle = styled.div`
  display: none;
  ${BREAKPOINTS.MEDIUM}{
    display: flex;
  }
  width: 52px;
  height: 52px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${COLORS.primary_100};
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const MainText = styled.div`
  color: ${COLORS.primary_700};
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
`;

const SubText = styled.div`
  color: ${COLORS.primary_700};
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
`;

const ContactAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: ${COLORS.primary_600};
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;

  svg {
    color: ${COLORS.primary_600};
  }
`;

const CantFindCreateCase = () => {
  const { t } = useTranslation('translation');

  const currentMartketPath = useSelector(selectMarketPath);
  const navigate = useNavigate()

  const goToSupport = () => {
    posthog?.capture('SUPP-GetSupport', {
      url: window.location.href,
      ref: document.referrer
    });

    navigate(`${currentMartketPath}/case/create`);
  };

  return (
    <Contact onClick={goToSupport}>
      <IconCircle>
        <SystemIcons.Help size="36px" color={COLORS.primary_500} />
      </IconCircle>
      <TextColumn>
        <MainText>{t('Couldn’t find what you need?')}</MainText>
        <SubText>{t('Click here to get personalized help from our support team.')}</SubText>
      </TextColumn>
      <ContactAction>
        {t('Contact support')} <SystemIcons.ArrowLineRight size="24px" />
      </ContactAction>
    </Contact>
  );
}

export default CantFindCreateCase;

